require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ignite-workshop-on-financial-modelling.json") })
        }
      }, "path---ignite-workshop-on-financial-modelling");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ignite-workshop-on-financial-modelling!./.cache/json/ignite-workshop-on-financial-modelling.json
// module id = 1105
// module chunks = 231608221292675